import { type ReactNode } from 'react';

import { type IOption } from '../IOption';

export class Option<Label extends ReactNode, Value extends string | number = string> implements IOption<Label, Value> {
  public readonly label: Label;

  public readonly value: Value;

  public constructor(label: Label, value: Value) {
    this.label = label;
    this.value = value;
  }
}
